(function ($, root, undefined) {

	$(function () {

		'use strict';

    // https://github.com/miguel-perez/smoothState.js
    var $body = $('body');
    var $loader = $('#loader');
    var $transition = $('.transition-box');

    var $page = $('#main'),
    options = {
      debug: true,
      blacklist: ".no-smoothstate, a[href*='.jpg'], a[href*='.png'], a[href*='.jpeg'], a[href*='.pdf']",
      prefetch: false,
      loadingClass: 'onload',
      scroll: true,
      cacheLength: 0,
      forms: 'search',
      onStart: {
        duration: 0, // Duration of our animation
        render: function ($container) {
          // Add your CSS animation reversing class
          // $container.addClass('onload');
          // $loader.addClass("start");
          // Restart your animation
          smoothState.restartCSSAnimations();
          $body.addClass("beforeload");
        }
      },
      onProgress: {
        // How long this animation takes
        duration: 1300,
        // A function that dictates the animations that take place
        render: function ($container) {
          $body.removeClass("loaded");
          $transition.addClass("moving-effect");
          $body.removeClass("beforeload");
          // $body.addClass("onload");
        }
      },
      onReady: {
        duration: 0,
        render: function ($container, $newContent) {
          // Remove your CSS animation reversing class
          // $container.removeClass('onload');
          // $body.removeClass("onload");
          $body.addClass("loaded");
          $transition.removeClass("moving-effect");
          // $(".wrapLoader").removeClass("loading");
          // Inject the new content
          $container.html($newContent);
          initSite();
        }
      },
      onAfter : function($container, $newContent) {
          // $body.removeClass("onload");
          // $loader.removeClass("start");
      }
    },
    smoothState = $page.smoothState(options).data('smoothState');

    // -------- End smoothState ------------


    // window.onload = load;

    // function load(){
    //  $('body').addClass('loaded');
    // }

		// $(document).ready(function(){
		// 	$('body').removeClass('onload');
		// });

		// $("a").on('click', function(){
    // $('body').removeClass('loaded');
		// 	if ( $(this).attr('target') == '_blank' ) {

		// 	} else {
		// 		$('body').addClass('onload');
		// 	}
		// });

		// $('a[href^="mailto"], a[href^="/#"]').on('click', function(){
		// 	// alert("c'est un mailto");
		// 	$('body').removeClass('onload');
		// });

		$('a:not([href])').click(function(e) {
		    e.preventDefault();
		    window.location.href = '/';
		});

		// $('.nav a[href^="/#"]').on('click', function (e) {
		// 	$('#toggle-nav').removeAttr('checked');
		// });

    $('.nav a').on('click', function (e) {
      $('#toggle-nav').removeAttr('checked');
    });

    initSite();

    function initSite() {


      // RECAPTCHA GOOGLE

      ( function( grecaptcha, sitekey ) {

        var wpcf7recaptcha = {
          execute: function() {
            grecaptcha.execute(
              sitekey,
              { action: 'homepage' }
            ).then( function( token ) {
              var forms = document.getElementsByTagName( 'form' );

              for ( var i = 0; i < forms.length; i++ ) {
                var fields = forms[ i ].getElementsByTagName( 'input' );

                for ( var j = 0; j < fields.length; j++ ) {
                  var field = fields[ j ];

                  if ( 'g-recaptcha-response' === field.getAttribute( 'name' ) ) {
                    field.setAttribute( 'value', token );
                    break;
                  }
                }
              }
            } );
          }
        };

        grecaptcha.ready( wpcf7recaptcha.execute );

        document.addEventListener( 'wpcf7submit', wpcf7recaptcha.execute, false );

      } )( grecaptcha, '6LcchLsUAAAAAIVaKbiAD-ClfSTwSsk3q0Z76vBL' );



      $(".slider").owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: false,
        nav: false,
        // navText: [ '<', '>' ],
        dots: true,
        smartSpeed: 700,
        responsiveClass:true,
        responsive:{
            0:{
                nav:false
            },
            600:{

            },
            979:{

            }
        }
      });

      $(".slide-realisations").owlCarousel({
        items: 1,
        loop: false,
        autoplay: false,
        mouseDrag: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: false,
        nav: false,
        // navText: [ '<', '>' ],
        dots: true,
        center: true,
        smartSpeed: 700,
        responsiveClass:true,
        responsive:{
            0:{
                nav:false
            },
            600:{

            },
            979:{

            }
        }
      });

      $(".clientsCarousel").owlCarousel({
        items: 3,
        loop: true,
        autoplay: true,
        autoplayTimeout: 4000,
        nav: false,
        // autoWidth: true,
        // navText: [ '<', '>' ],
        dots: false,
        smartSpeed: 700,
        responsiveClass:true,
        responsive:{
            0:{
              nav:false,
              items: 1
            },
            780:{
              items: 3
            },
            1140:{
              items: 5
            }
        }
      });

      $(".aproposCarrousel").owlCarousel({
        items: 6,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        nav: true,
        // autoWidth: true,
        navText: [ '', '' ],
        margin:30,
        dots: false,
        smartSpeed: 3000,
        responsiveClass:true,
        responsive:{
            0:{
              nav:false,
              items: 1
            },
            480:{
              items: 2
            },
            780:{
              items: 2
            },
            1140:{
              items: 4
            }
        }
      });

      $(".taxonomy-realisation-list").owlCarousel({
        screenLeft:true,
        items: 3,
        loop: true,
        autoplay: true,
        autoplayTimeout: 4000,
        nav: true,
        margin:30,
        center: true,
        startPosition: 'left',
        // autoWidth: true,
        navText: [ '', '' ],
        dots: false,
        smartSpeed: 4000,
        responsiveClass:true,
        responsive:{
            0:{
              nav:false,
              items: 1
            },
            480:{
              items: 1
            },
            780:{
              items: 2
            },
            1140:{
              items: 3
            }
        }
      });

      if ($('#content').hasClass('home') || $('#content').hasClass('contact') ) {

        // https://cocopon.me/app/vanillabox/index.html

        $('.pop-home').vanillabox({
            type: 'iframe',
            // preferredWidth: 900,
            // preferredHeight: 600,
            closeButton: true,
            repositionOnScroll: true,
            grouping: false
        });

      }

    }


		// Si l'on est sur la Home

		if ($('body').hasClass('home')) {

		  		$('header .nav a[href^="/#"]').on('click', function (e) {

			    e.preventDefault();
			    $(document).off("scroll");

			    $('a').each(function () {
			          $(this).removeClass('active');
			      });

			    $(this).addClass('active');

			    // $('#toggle-nav').removeAttr('checked');

			    var target = this.hash,
			        menu = target,
			    	$target = $(target);
			    $('html, body').stop().animate({
			          'scrollTop': $target.offset().top-75
			      }, 500, '', function () {
			          window.location.hash = target;
			          $(document).on("scroll", onScroll);
			    });

			    // console.log(this.hash);
		        // console.log("Je clic !!");
			});

	    $(document).on("scroll", onScroll);
	    var navLinks = $("header .nav a");
	    var sections = [];
	    navLinks.each(function (i) {
	        var currLink = $(this);
	        var refElement = currLink.attr("href");
	        refElement = refElement.split("/");
	        try{
	            refElement = $(refElement[1]);
	            refElement.data("lienCorrespondant", currLink);
	            sections.push(refElement);
	        } catch(e) {
	            //....
	            // console && console.warn(e);
	        }
	    });
	    sections = $(sections);

	    // function onScroll(event){

	    //     var scrollPos = $(document).scrollTop();

	    //     var found = false;
	    //     sections.each(function (i) {
	    //         if(found !== false) return;
	    //         var refElement = $(this);
	    //         // console.log(refElement.offset().top);
	    //         var pos = refElement.offset(), height = refElement.height();
	    //         var isActive = pos && pos.top <= scrollPos && pos.top + height > scrollPos;
	    //         // console.log(i, scrollPos, pos, height, isActive);

	    //         if (isActive) {
	    //             found = i;
	    //             refElement.data("lienCorrespondant").addClass("active");
	    //         }
	    //     });
	    //     if(found !== false){
	    //         sections.each(function (i) {
	    //             if(i === found) return; /// c'est l'élément actif
	    //             if(typeof $(this).data("lienCorrespondant") !== "undefined"){
	    //             	$(this).data("lienCorrespondant").removeClass("active");
	    //             }
	    //         });
	    //     }
	    // }
		} else {
		  // console.log("Pas la Home !!");
		}


	});

})(jQuery, this);

(function($, undefined) {
    var isFired = false;
    var oldReady = jQuery.fn.ready;
    $(function() {
        isFired = true;
        $(document).ready();
    });
    jQuery.fn.ready = function(fn) {
        if(fn === undefined) {
            $(document).trigger('_is_ready');
            return;
        }
        if(isFired) {
            window.setTimeout(fn, 1);
        }
        $(document).bind('_is_ready', fn);
    };

})(jQuery);

